import React, { Component } from 'react';
import { UserComponent } from 'react/UserComponent.jsx';


class StateMessagesComponent extends React.Component {
	render() {
		const { stateMessages } = this.props;
		const elements = [];
		Array.from(stateMessages.values()).forEach((stateMessage) => {
			const player = stateMessage.player;
			if(player.isMe()) {
				return null;
			}
			elements.push(
				<div key={player.id} className='state_message'><UserComponent user={player} /><span className='message'> is typing</span>
				</div>
			);
		});
		if(!elements.length) {
			return null;
		}

		return (
			<div className='state_messages'>{elements}</div>
		);
	}
}

export { StateMessagesComponent };